import { useMemo } from "react";
import { computeComparison } from "@/lib/pricing";
// Groups all pricing inputs and derived mileage into one hook so the page
// component stays simple and the memo dependencies live in one place.
export function usePricing({
  stopValues,
  manualMiles,
  routeData,
  cost,
  overnight,
  backhaul,
  bonus,
  carrierBids,
  bidMarginPct,
}) {
  const numStops = stopValues.filter((s) => s.trim()).length;
  const effectiveMiles = manualMiles !== "" ? Number(manualMiles) : routeData?.total_miles || 0;
  // One-way miles (just getting there): manual override (round trip) takes precedence and is halved;
  // otherwise route total minus the return-to-pickup leg.
  const oneWayMiles =
    manualMiles !== ""
      ? Number(manualMiles) / 2
      : routeData?.legs?.length
        ? Math.max(0, routeData.total_miles - (routeData.legs[routeData.legs.length - 1]?.miles || 0))
        : 0;

  const totalMinutes = routeData?.total_minutes || 0;
  const result = useMemo(
    () =>
      computeComparison({
        numStops,
        totalMiles: effectiveMiles,
        oneWayMiles,
        driveMinutes: totalMinutes,
        costInputs: cost,
        overnight,
        backhaul,
        bonus,
        outsourced: { bids: carrierBids, marginPct: bidMarginPct },
      }),
    [numStops, effectiveMiles, oneWayMiles, totalMinutes, cost, overnight, backhaul, bonus, carrierBids, bidMarginPct]
  );

  return { numStops, effectiveMiles, oneWayMiles, result };
}
